<template>
  <a
    v-if="typeof item == 'object'"
    class="result"
    :href="item.is_document ? item.is_document : item.link"
    :target="item.is_document ? '_blank' : '_self'"
  >
    <div class="image illust">
      <span v-if="item.acf_if_podcast" class="icon-card-podcast">
            <svg><use xlink:href="#icon-card-podcast"></use></svg>
      </span>
      <span v-if="item.acf_if_video" class="icon-card-artefact">
            <svg><use xlink:href="#icon-card-artefact"></use></svg>
      </span>
      <span v-if="item.acf_if_info" class="icon-card-info">
            <svg><use xlink:href="#icon-card-info"></use></svg>
      </span>
      <span v-if="item.acf_if_article" class="icon-card-article">
            <svg><use xlink:href="#icon-card-article"></use></svg>
      </span>
      <img :src="item.featured_media_url" />
    </div>
    <div class="description">
      <div class="type">
        {{ item.acf_format }}
      </div>
      <h5 class="title" v-if="item.title">
        {{ item.title.rendered  | truncate(100, '...') }}
      </h5>
      <span class="introduction">
        {{item.acf_intro | truncate(100, '...') }}
      </span>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    assetUrl: {
      type: String,
      required: true
    },
  },
};
</script>

<style lang="scss" scoped>
</style>